var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalibration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.097,
    height: 24.099,
    viewBox: "0 0 24.097 24.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.997 -1.987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,3.075a5.388,5.388,0,0,1,4.536,2.454.522.522,0,1,0,.88-.56,6.469,6.469,0,0,0-10.833,0,.525.525,0,1,0,.88.571A5.388,5.388,0,0,1,7.5,3.075Z",
    transform: "translate(0 -0.036)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.824,13.56a.519.519,0,1,0,.89-.532,4.528,4.528,0,0,0-7.747,0,.525.525,0,1,0,.9.542,3.478,3.478,0,0,1,5.951,0Z",
    transform: "translate(-4.351 -6.538)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,21.65a1.909,1.909,0,0,1,1.485.7.524.524,0,1,0,.809-.665,2.975,2.975,0,0,0-4.589,0,.524.524,0,1,0,.809.665A1.909,1.909,0,0,1,16.2,21.65Z",
    transform: "translate(-8.7 -13.74)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.426,12.205a10.215,10.215,0,0,0-12.7-9.911.525.525,0,0,0,.262,1.016,9.167,9.167,0,0,1,7.1,16.655.524.524,0,0,0-.118.052,9.049,9.049,0,0,1-9.523,0,.524.524,0,0,0-.118-.052,9.12,9.12,0,0,1-4.287-7.76,9.306,9.306,0,0,1,.215-1.983A.524.524,0,0,0,16.238,10a10.215,10.215,0,0,0,4,10.495,6.5,6.5,0,0,0-2.407,5.071.524.524,0,0,0,.524.524H34.068a.524.524,0,0,0,.524-.524,6.5,6.5,0,0,0-2.407-5.071A10.154,10.154,0,0,0,36.426,12.205Zm-2.9,12.834H18.9a5.463,5.463,0,0,1,2.279-3.95,10.071,10.071,0,0,0,2.412.987h.042c.191.05.382.094.576.134.06.013.12.021.181.031.155.029.309.055.464.076.113.016.225.024.338.037s.217.024.327.031q.348.034.691.034t.684-.024c.11,0,.217-.021.327-.031s.225-.021.338-.037c.155-.021.309-.047.461-.076a.866.866,0,0,0,.183-.031c.194-.039.385-.084.576-.134h.042a10.07,10.07,0,0,0,2.42-.987A5.463,5.463,0,0,1,33.521,25.039Z",
    transform: "translate(-10.332 0)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,27.476A4.976,4.976,0,1,0,40.976,22.5,4.976,4.976,0,0,0,36,27.476Zm4.976-3.929a3.929,3.929,0,1,1-3.929,3.929,3.929,3.929,0,0,1,3.929-3.929Z",
    transform: "translate(-25.097 -15.14)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.524,33.9a.524.524,0,0,0,.524-.524,1.833,1.833,0,0,1,1.833-1.833.524.524,0,0,0,0-1.048A2.881,2.881,0,0,0,44,33.381a.524.524,0,0,0,.524.524Z",
    transform: "translate(-31.002 -21.045)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalibration);
export default __webpack_public_path__ + "static/media/calibration.cdd1abc0.svg";
export { ForwardRef as ReactComponent };